import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx, Icon } from '@a-type/ui';
import { useContext, useEffect, useState } from 'react';
import { VerdantContext } from '../verdant.js';
import cls from './GlobalSyncingIndicator.module.css';
export function GlobalSyncingIndicator({}) {
    const [syncing, setSyncing] = useState(false);
    const client = useContext(VerdantContext);
    useEffect(() => {
        return client === null || client === void 0 ? void 0 : client.sync.subscribe('syncingChange', setSyncing);
    }, [client]);
    if (!client)
        return null;
    return (_jsxs("div", { className: clsx(cls.root, '@mode-denser', {
            'opacity-100': syncing,
        }), "aria-hidden": !syncing, children: [_jsx(Icon, { name: "refresh", className: cls.spin }), _jsx("span", { children: "Syncing" })] }));
}
//# sourceMappingURL=GlobalSyncingIndicator.js.map